import moment from 'moment'
import React, { useState } from 'react'
import { useAppDispatch } from '../../../hooks/redux-hooks'

import { trimUsername } from '../../../utils/index'

import styles from './History.module.css'

import { getCustomerEligibleCombosHistory } from '../../../store/services/CustomerDetails.services'

type TProps = {
  data: any
}

const cleanHistory = (item: any, index: number) => {
  return (
    <li key={index}>
      <p>
        {item.scoreType} score - {item.score} {item.action}d {' '} by <strong>{trimUsername(item.updatedBy) || item.updateMedium}</strong> {item.remarks && ` with remarks "${item.remarks}"`}
      </p>
      <span>{item.updatedDate}</span>
      <span className={styles.date_info}>{moment(item.updatedDate).fromNow()}</span>
    </li>
  )
}

const comboHistory = (eligibleCombos: any[], timeStamp?: string) => {
  if (!eligibleCombos?.length) {
    return null
  }

  return (
    <li className={styles.comboHistoryItem}>
      {timeStamp && <>
        <span>{timeStamp}</span>
        <span className={styles.date_info}>{moment(timeStamp).fromNow()}</span>
      </>}
      <table className={styles.comboHistory}>
        <thead>
          <tr>
            <td>Product</td>
            <td>Combo</td>
            <td>Eligibility</td>
          </tr>
        </thead>
        <tbody>
          {eligibleCombos.map((combo: any, idx: number) => (
            <tr key={idx}>
              <td>{combo.products?.[0]?.sku ?? '-'}</td>
              <td>{combo.name}</td>
              <td>{combo.eligibilities?.advancePayment?.value ?? '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </li>
  )
}

function History({ data }: TProps) {
  const [showCombos, setShowCombos] = useState(false)

  const [comboHistoryList, setComboHistoryList] = useState<any[]>([])

  const dispatch = useAppDispatch()

  const [buttonDisabled, setButtonDisabled] = useState(false)

  const handleShowCombos = async () => {

    setButtonDisabled(true)

    if (data?.length) {
      for (const item of data) {

        const action: any = await dispatch(getCustomerEligibleCombosHistory({ finalScore: item.score, productId: 'PF365', tenure: item.tenure, ARPU: item.ARPU, CV: item.CV }))

        if (action.payload?.data) {
          setComboHistoryList(prev => [
            ...prev,
            {
              eligibleCombos: action.payload.data.eligibleCombos,
              timeStamp: item.updatedDate
            }
          ])
        }
      }
    }

    setShowCombos(true)
  }

  return (
    <div className={styles.historyContainer}>
      <div className={styles.title}>
        <h2 data-testid="recent-history-title">History</h2>
      </div>
      <div className={styles.historyBody}>
        <ul>
          {
            data?.length ? data.map((item: any, index: number) => {
              return cleanHistory(item, index)
            }) : (
              <li>
                <p>
                  Loading history...
                </p>
              </li>
            )
          }
        </ul>
        <div>
          {!showCombos ? (
            <button
              className={styles.primaryBtn}
              onClick={handleShowCombos}
              type="button"
              disabled={buttonDisabled}
            >
              {buttonDisabled ? 'Loading...' : 'Show Eligible Combos'}
            </button>
          ) : (
            <>
              {comboHistoryList.map((entry, idx) => (
                <React.Fragment key={idx}>
                  {comboHistory(entry.eligibleCombos, entry.timeStamp)}
                </React.Fragment>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default History
